document.addEventListener('DOMContentLoaded', function () {
  const $root = $('.js-auth__mfa-setup')

  // elements
  const $input = $root.find('.js-auth__mfa-code')
  const $error = $root.find('.js-auth__error')

  if (!$root.length) return

  $root.submit(function (e) {
    e.preventDefault()

    const code = $input.val()
    const secret = $input.data('secret')

    $.ajax({
      type: 'post',
      data: {
        code,
        secret,
      },
      complete: function (request) {},
      url: '/admin/secret',
    }).done(res => {
      $error.html('')
      $error.hide()

      if (res.success) {
        window.location.href = res.redirect_url
        return
      }

      $error.html(res.error.message)
      $error.show()
      $input.focus()
    })
  })
})
